import React from 'react';
import { useTranslation } from 'react-i18next';

import classes from './Segment.module.css';

import { ReactComponent as PlaneIcon } from '../../../../assets/icons/plane-icon.svg';


const Location = (props) => {
  const headerClasses = [
    props.boldH ? classes.Bold: '',
    classes.LocationHeader
  ];
  return(
    <div className={classes.Location}>
      <h5 className="sr-only"> {props.title} </h5>
      <div className={headerClasses.join(' ')}>
        {props.header}
      </div>
      <div className={classes.Airport}>
        {props.airport}
      </div>
      <div className={classes.City}>
        {props.city}
      </div>
      <div className={classes.Hour}>
        {props.hour}
      </div>
    </div>
    
  )
 
}

const Segment = (props) =>{
  const {t} = useTranslation('global');

  const type = props.payload.type === "OUTWARD" ? t('checkIn.segment.outward') : t('checkIn.segment.return');
  const months = t('checkIn.segment.months').split(',');
  const month = months[parseInt(props.payload.departureMonth-1)];
  // parseInt(props.payload.departureMonth);

  const passengers = props.passengers.map((psg, index)=>{
    const passanger = props.passengersState.find(item=>item.id === psg.id);
    return (
    <label key={index}>
      <input type="checkbox" checked={passanger.checked} onChange={(event)=>props.checkPassenger(event.target.checked, props.payload.id, psg.id)}/>
      {`${psg.name} ${psg.surname}`}
    </label>
    )
  })

  return (
    <div className={classes.Segment}>
      <div className={classes.LocationContainer}>
        <Location 
          boldH={true}
          title={ t('checkIn.segment.departure')}
          airport={props.payload.departureCity}
          city={props.payload.departureIATA}
          hour={props.payload.departureHour}
          header={type}
        />
        <div className={classes.Plane}>
          <PlaneIcon/>
        </div>
        <Location 
          title={ t('checkIn.segment.arrival')}
          airport={props.payload.arrivalCity}
          city={props.payload.arrivalIATA}
          hour={props.payload.arrivalHour}
          header={`${props.payload.departureDay} ${month}.`}
        />
        </div>
      
      <div className={classes.Passengers}>
        {passengers}
      </div>

    </div>
  )
}

export default Segment;